
<template>
    <div id='statingEndPoint'>
      <div class="tabs_content">
        <div class="content">
          <div class="top">
            <div class="left">
              <div class="h">{{$t("shipmentStarEnd.start")}}</div>
              <!-- 选择框 -->
              <el-select id="startSelect" v-model="startshipment" :placeholder="$t('shipmentStarEnd.startPlacehodler')" @change="handstartChange">
                <el-option
                  v-for="item in startshipmentList"
                  :key="item.id"
                  :label="item[_i18n.locale == 'en' ? 'nameEC' : 'name']"
                  :value="item.id"
                  >
                  <div @click="setimage('startSelect',item.image)">
                    <img :src="`http://goods2go.com.hk/goods2go-user/img/${item.image}`" alt="country">
                    <span>{{item[_i18n.locale == 'en' ? 'nameEC' : 'name']}}</span>
                  </div>
                </el-option>
              </el-select>
            </div>
            <div class="changeBtn" @click="swich">
              <!-- <div class="changeBtn"> -->
              <span class="el-icon-refresh"></span>
            </div>
            <div class="right">
              <div class="h">{{$t("shipmentStarEnd.end")}}</div>
            <!-- 选择框 -->
            <el-select v-model="endshipment" id="endSelect" :placeholder="$t('shipmentStarEnd.endPlacehodler')" @change="setEndshipment">
              <el-option
                v-for="item in endshipmentList"
                :key="item.id"
                :label="item[_i18n.locale == 'en' ? 'nameEC' : 'name']"
                :value="item.id">
                <div @click="setimage('endSelect',item.image)">
                  <img :src="`http://goods2go.com.hk/goods2go-user/img/${item.image}`" alt="country">
                  <span>{{item[_i18n.locale == 'en' ? 'nameEC' : 'name']}}</span>
                </div>
              </el-option>
            </el-select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    // 引入组件
    export default {
      mame:'StatingEndPoint',
      components:{
      },
      data() {
        return {
          // 起点
          startshipment:'',
          // 终点
          endshipment:'',
          // 收货地选项
          endshipmentList:[
          ],
          // 发货地选项
          startshipmentList:[
          ],
          // 起点名称
          startName: '',
          // 终点名称
          endName: ''
        }
    },
      methods: {
        // 获取起点城市
        async getStartshipmentList(){
          let res = await this.$http.get(`/app/data/listStartRegion`)
          this.startshipmentList = res.data.data
        },
        // 监听用户获取起点城市
        handstartChange(value){
          this.endshipment = ''
          this.endshipmentList = []
          document.querySelector("#endSelect").style.background = 'none'
          document.querySelector("#endSelect").style.backgroundRepeat = 'no-repeat'
          this.getEndshipmentList(value)
          this.startName =  this.getCountruNameById(this.startshipmentList, this.startshipment-0)
          
        },
        // 获取终点城市
        async getEndshipmentList(id){
          let res = await this.$http.get(`/app/data/listEndRegion?statusId=${id}`)
          this.endshipmentList = res.data.data
          console.log(res,"终点国家")
        },
        // 监听用户选择终点城市
        setEndshipment(value){

          this.endName =  this.getCountruNameById(this.endshipmentList, this.endshipment-0)

          // 把数据交给vuex
          this.$store.commit('SETSHIPMENT',{
            startName: this.startName,
            endName: this.endName,
            startId: this.startshipment-0,
            endId: this.endshipment-0
          })
        },
        // 根据id获取国家名称
        getCountruNameById(list,id){
          let name = undefined
          list.forEach(item => {
            if(item.id == id){
              name = item.name
            }
          });

          return name
        },
        // 监听用户点击切换终点起点按钮
        async swich(){
          if(this.endshipment == '' || this.startshipment == '') return this.$message.error("请先选择起始点和终点")
          let temp = this.startshipment
          this.startshipment = this.endshipment 
          this.endshipment = temp

          let shipmentTemp =  this.startshipmentList
          this.startshipmentList = this.endshipmentList
          this.endshipmentList = shipmentTemp
          let valid = await this.searcHasHRoute(this.startshipment-0,this.endshipment-0)

          let nameTemp = this.startName
          this.startName = this.endName
          this.endName = this.nameTemp
          if(!valid) return
          this.$store.commit('SETSHIPMENT',{
            startName: this.getCountruNameById(this.startshipmentList, this.startshipment-0),
            endName: this.getCountruNameById(this.endshipmentList, this.endshipment-0),
            startId: this.startshipment-0,
            endId: this.endshipment-0
          })
          // 换图片
          let startTemp = document.querySelector("#startSelect").style.backgroundImage
          document.querySelector("#startSelect").style.backgroundImage = document.querySelector("#endSelect").style.backgroundImage
          document.querySelector("#endSelect").style.backgroundImage = startTemp
        },
        // 查询是否有线路
        async searcHasHRoute(startId,endId){
          let valid 
          let res = await this.$http.get(`app/v2/getRoute`,{
            params:{
              startId,
              endId
            }
          })
          valid = res.data.data
          console.log(res,"是否有线路")
          if(!valid) return this.$message.error("沒有該線路資訊")
          return valid
        },
        // 用户选择起始地或终止地设置图片
        setimage(el,image){
          let Ipt = document.querySelector("#"+el)
          Ipt.style.backgroundImage = `url(http://goods2go.com.hk/goods2go-user/img/${image})`
          Ipt.style.backgroundSize = "30px 22px"
          Ipt.style.backgroundPosition= "5px"

          // 交给vuex保存
          this.$store.commit("SETIMAGE",{el,image})
        }
      },
      // 生命周期挂载完成
      mounted() {
        // 获取起点和终点城市
        this.getStartshipmentList()
        // 更新之前选过的起点终点
        this.startshipment = this.$store.state.budgetForm.startId
        if(this.startshipment){
          this.getEndshipmentList(this.startshipment)
          document.getElementById("startSelect").style.backgroundImage = `url(http://goods2go.com.hk/goods2go-user/img/${this.$store.state.startSelect})`
          document.getElementById("startSelect").style.backgroundSize = "30px 22px"
          document.getElementById("startSelect").style.backgroundPosition= "5px"
          document.getElementById("endSelect").style.backgroundImage = `url(http://goods2go.com.hk/goods2go-user/img/${this.$store.state.endSelect})`
          document.getElementById("endSelect").style.backgroundSize = "30px 22px"
          document.getElementById("endSelect").style.backgroundPosition= "5px"
        }
        this.endshipment = this.$store.state.budgetForm.endId
      },
    }
  </script>
  
  <style lang="less" >  
  #statingEndPoint{

    .top{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        width: 100%;
        height: 110px;
        .el-select{
          width: 575px;
          .shadowSelect();
          .el-input__inner{
            background-repeat: no-repeat;
            padding-left: 40px;
          }
        }
            input{
            height: 56px !important;
            }
        .h{
        margin-bottom: 20px;
        font-size: 17px;
        font-weight: 550;
        span{
            font-weight: 500;
            font-size:12px;
            color:@colorMain;
            margin-left:10px;
        }
      }
        .changeBtn{
            width: 35px;
            height: 35px;
            border-radius: 50%;
            background-color: @colorMain;
            text-align: center;
            line-height: 35px;
            color: #fff;
            font-size: 18px;
            margin:0  44px;
            margin-top: 33px;
            &:hover{
                cursor: pointer;
                opacity: .8;
            }
        }
    }
  }
    .el-select-dropdown{
      .el-scrollbar{
        .el-select-dropdown__wrap{
          .el-scrollbar__view{
            .el-select-dropdown__item{
              height: 45px;
              line-height: 45px;
              div{
                height: 45px;
                line-height: 45px;
                display: flex;
                align-items: center;
                img{
                  width: 30px !important;
                  height: 22px !important;
                  margin-right: 5px;
                }
                span{
                  display: inline-block;
                  width: 30px !important;
                  height: 22px !important;
                  line-height: 22px;
                }
              }
            }
          }
        }
      }
    }
    /* 最大宽度768px 手机 */
    @media screen and (max-width: 768px){

    }
  </style>